import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";


const Personal = (props) => {
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange,
    genderList,
          nationalityList,
          maritalStatusList,
          countryList,
          cityList
  } = props;
  const { t } = useTranslation(); 
  let birthdate = values.baseFields?.birthDate
    ? values.baseFields?.birthDate.substring(0, 10)
    : "";

  return (
  
    <Card>
      <CardHeader title={t("pages.workerregister.personal.stepname")} />

      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.firstname")}
              name="baseFields.firstName"
              error={Boolean(
                touched.baseFields?.firstName && errors.baseFields?.firstName
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.firstName ||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.lastName")}
              name="baseFields.lastName"
              error={Boolean(
                touched.baseFields?.lastName && errors.baseFields?.lastName
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.lastName||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.middleName")}
              name="baseFields.middleName"
              error={Boolean(
                touched.baseFields?.middleName && errors.baseFields?.middleName
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.middleName ||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.nationalityCode")}
              name="baseFields.nationalityCode"
              select
              SelectProps={{ native: true }}
              error={Boolean(
                touched.baseFields?.nationalityCode &&
                  errors.baseFields?.nationalityCode
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.nationalityCode||undefined}
            >
              {nationalityList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.emailAddress")}
              name="baseFields.emailAddress"
              error={Boolean(
                touched.baseFields?.emailAddress &&
                  errors.baseFields?.emailAddress
              )}
              helperText={
                touched.baseFields?.emailAddress &&
                errors.baseFields?.emailAddress
              }
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.emailAddress||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.privatePhoneNumber")}
              name="baseFields.privatePhoneNumber"
              error={Boolean(
                touched.baseFields?.privatePhoneNumber &&
                  errors.baseFields?.privatePhoneNumber
              )}
              helperText={
                touched.baseFields?.privatePhoneNumber &&
                errors.baseFields?.privatePhoneNumber
              }
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.privatePhoneNumber||''}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.genderCode")}
              name="baseFields.genderCode"
              select
              SelectProps={{ native: true }}
              error={Boolean(
                touched.baseFields?.genderCode && errors.baseFields?.genderCode
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.genderCode||undefined}
            >
              {genderList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.maritalStatusCode")}
              name="baseFields.maritalStatusCode"
              select
              SelectProps={{ native: true }}
              error={Boolean(
                touched.baseFields?.maritalStatusCode &&
                  errors.baseFields?.maritalStatusCode
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.maritalStatusCode||undefined}
            >
              {maritalStatusList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label={t("worker.birthDate")}
              name="baseFields.birthDate"
              type="date"
              InputLabelProps={{ shrink: true }}
              error={Boolean(
                touched.baseFields?.birthDate && errors.baseFields?.birthDate
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={birthdate||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("worker.birthPlace")}
              name="baseFields.birthPlace"
              error={Boolean(
                touched.baseFields?.birthPlace && errors.baseFields?.birthPlace
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.birthPlace||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label={t("address.countryCode")}
              name="baseFields.address.countryCode"
              select
              SelectProps={{ native: true }}
              InputLabelProps={{
                shrink: true,
              }}
              error={Boolean(
                touched.baseFields?.address?.countryCode &&
                  errors.baseFields?.address?.countryCode
              )}
              onBlur={handleBlur}
              onChange={(event) => {
                handleChange(event);
                props.getResult(event.target.value + "Cities");
              }}
              value={values.baseFields?.address?.countryCode||undefined}
            >
              {countryList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("address.city")}
              name="baseFields.address.city"
              select
              SelectProps={{ native: true }}
              error={Boolean(
                touched.baseFields?.address?.city &&
                  errors.baseFields?.address?.city
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.address?.city||undefined}
            >
              {cityList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("address.postCode")}
              name="baseFields.address.postCode"
              error={Boolean(
                touched.baseFields?.address?.postCode &&
                  errors.baseFields?.address?.postCode
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.address?.postCode||''}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              label={t("address.detail")}
              name="baseFields.address.detail"
              error={Boolean(
                touched.baseFields?.address?.detail &&
                  errors.baseFields?.address?.detail
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.address?.detail||''}
            />
          </Grid>
        </Grid>
      </CardContent>

      {/* Master state */}
      <pre>{JSON.stringify(props.values, null, 2)}</pre>
    </Card>
  
  );
};

export default Personal;
